import React from "react";
import { useNavigate } from "react-router-dom";

import NaytaPaluuNappi from "./NaytaPaluuNappi";

const Maksutapa = (props) => {
  const navigate = useNavigate();

  function handleClick(event) {
    navigate("/tilaa/" + event.target.value);
  }
  return (
    <form>
      <h3>Valitse toimitus- ja maksutapa:</h3>
      <table id="maksutapa" align="center">
        <tbody>
          <tr>
            <td>
              <input
                type="radio"
                id="nouto"
                name="maksutapa"
                value="nouto"
                onClick={handleClick}
              />
              <label for="nouto">Nouto, käteinen/MobilePay</label>
            </td>
          </tr>
          <tr>
            <td>
              <input
                type="radio"
                id="posti"
                name="maksutapa"
                value="posti"
                onClick={handleClick}
              />
              <label for="posti">Posti, ennakkomaksu</label>
            </td>
          </tr>
        </tbody>
      </table>
      <NaytaPaluuNappi kohde={"/kori"} />
    </form>
  );
};
export default Maksutapa;
